// extracted by mini-css-extract-plugin
export var arrows = "_2c-5";
export var decrementer = "_2c-9";
export var disabled = "_2c-3";
export var error = "_2c-1";
export var hiddenText = "_2c-a";
export var incrementer = "_2c-8";
export var input = "_2c-7";
export var inputWrapper = "_2c-0";
export var leadingIcon = "_2c-b";
export var readonly = "_2c-2";
export var regular = "_2c-6";
export var small = "_2c-4";